import { Scrn, Box, Ln, Bar, GradBtn, ChipRow, Tick } from "./atoms";

export const CustomPlanScreen = () => (
    <Scrn title="Plan Builder" badge="Advanced">
        <Box className="border-[#f0356f]/20">
            <p className="text-[10px] font-extrabold text-white">My Push Day · Custom</p>
            <p className="text-[8px] text-[#7d8da3]">Built by you · optional — your automated plan stays the default</p>
        </Box>
        {[
            ["Incline Press", "4 sets · 10 reps · 90s"],
            ["Cable Fly", "3 sets · 12 reps · 60s"],
        ].map(([n, d]) => (
            <Box key={n} className="flex items-center gap-2 !p-2">
                <div className="flex-1">
                    <p className="text-[9px] font-bold text-white">{n}</p>
                    <p className="text-[8px] text-[#7d8da3]">{d}</p>
                </div>
                <span className="text-[9px] text-[#3fcbf3]">✎</span>
            </Box>
        ))}
        <div className="rounded-lg border border-dashed border-white/15 p-2 text-center text-[8px] font-bold uppercase tracking-widest text-[#3fcbf3]">
            + Add Exercise
        </div>
        <div className="rounded-lg border border-dashed border-white/15 p-2 text-center text-[8px] font-bold uppercase tracking-widest text-[#f0356f]">
            + Add Custom Meal
        </div>
    </Scrn>
);

export const AdaptationScreen = () => (
    <Scrn title="Weekly Review" badge="Smart Adaptation">
        <div className="grid grid-cols-2 gap-2">
            <Box className="text-center"><p className="text-[13px] font-extrabold text-[#3fcbf3]">↑ 6%</p><p className="text-[7px] uppercase tracking-widest text-[#7d8da3]">Performance</p></Box>
            <Box className="text-center"><p className="text-[13px] font-extrabold text-white">88%</p><p className="text-[7px] uppercase tracking-widest text-[#7d8da3]">Adherence</p></Box>
        </div>
        <Box>
            <p className="mb-1 text-[8px] font-bold uppercase tracking-widest text-[#7d8da3]">Training volume · 4 weeks</p>
            <div className="flex h-8 items-end gap-1.5">
                {[40, 55, 62, 78].map((h, i) => (
                    <span key={i} className="flex-1 rounded-sm" style={{ height: `${h}%`, background: i === 3 ? "#3fcbf3" : "rgba(63,203,243,0.25)" }} />
                ))}
            </div>
        </Box>
        <Box className="border-[#3fcbf3]/25">
            <p className="text-[8px] font-bold uppercase tracking-widest text-[#3fcbf3]">Plan adjusted · Coach methodology</p>
            <p className="mt-0.5 text-[9px] leading-relaxed text-white">
                Calories −120 · +1 set on compounds · progression rate maintained
            </p>
        </Box>
    </Scrn>
);

export const LearningHubScreen = () => (
    <Scrn title="Learning Hub" badge="Education">
        <ChipRow items={["Training", "Nutrition", "Fat Loss", "Recovery"]} active={0} />
        <Box className="border-[#f0356f]/20 !p-0 overflow-hidden">
            <div className="h-9 w-full" style={{ background: "linear-gradient(120deg,#3a1226,#f0356f/40)" }} />
            <div className="p-2">
                <p className="text-[8px] font-bold uppercase tracking-widest text-[#f0356f]">Featured · 8 min read</p>
                <p className="text-[10px] font-extrabold text-white">Fat Loss, Explained</p>
            </div>
        </Box>
        {[
            ["Progressive Overload Basics", "Guide · 6 min", true],
            ["Protein 101", "Article · 4 min", true],
            ["Sleep & Recovery", "Video · 5 min", false],
        ].map(([n, d, done]) => (
            <Box key={n} className="flex items-center gap-2 !p-2">
                <div className="flex-1">
                    <p className="text-[9px] font-bold text-white">{n}</p>
                    <p className="text-[8px] text-[#7d8da3]">{d}</p>
                </div>
                <Tick done={done} />
            </Box>
        ))}
        <div>
            <div className="mb-1 flex justify-between text-[7px] font-bold uppercase tracking-widest text-[#7d8da3]">
                <span>Foundations path</span><span>Module 2 of 6</span>
            </div>
            <Bar w="33%" />
        </div>
    </Scrn>
);
